// extracted by mini-css-extract-plugin
export default {"rulesList":"rulesList---xofgl"};